import { render, staticRenderFns } from "./BlockmodePanel.vue?vue&type=template&id=15d0fb76&scoped=true&"
import script from "./BlockmodePanel.vue?vue&type=script&lang=js&"
export * from "./BlockmodePanel.vue?vue&type=script&lang=js&"
import style0 from "./BlockmodePanel.vue?vue&type=style&index=0&id=15d0fb76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d0fb76",
  null
  
)

export default component.exports